import { useEffect, useMemo, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { HeaderPcFormat } from '@/layouts/root-layout/header-pc-format.tsx'
import { useMobileSelect } from '@/hooks'

import { APP_ROUTES, APP_TITLES } from '../../constants.ts'
import { DrawerContext, DrawerStateCtx } from '../../contexts'
import { ScrollToTop, SnackbarProvider } from '../../components'

import { Header } from './header.tsx'
import { Footer } from './footer.tsx'

export const RootLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { isMobile } = useMobileSelect()

  useEffect(() => {
    if (location.pathname === '/') {
      navigate(APP_ROUTES.Login)
    }

    document.title = APP_TITLES[location.pathname] ?? 'Цифра | Эквайринг'
  }, [location.pathname])

  const ctxValue: DrawerStateCtx = useMemo(
    () => ({
      open: drawerOpen,
      toggleDrawer: (value: boolean) => () => setDrawerOpen(value),
    }),
    [drawerOpen]
  )

  const isLoginPage = location.pathname.includes(APP_ROUTES.Login)

  return (
    <DrawerContext.Provider value={ctxValue}>
      <ScrollToTop />
      <SnackbarProvider>
        {isLoginPage || isMobile ? <Header /> : <HeaderPcFormat />}
        <Outlet />
      </SnackbarProvider>
      <Footer />
    </DrawerContext.Provider>
  )
}
